import { gpHome } from '../../app';
import { SimpleProject } from '../../controllers/boards-controller';
import projectItemTemplate from './project-item.html';
import { ProjectItemController } from './project-item-controller';


gpHome.directive("gpProjectItem", ['$timeout', function($timeout: ng.ITimeoutService): ng.IDirective {
        return ({
            restrict: 'E',
            scope: {
                project: '=',
                currentUserEmail: '<?',
                update: '&'
            },
            link: ($scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {
                $scope.$watch(
                    () => controller.project,
                    (newValue: SimpleProject) => controller.reset()
                );

                // The autofocus attribute is unreliable on elements inserted
                // after page load, and Enter/Escape handling depends on the
                // input actually holding focus; defer until it is in the DOM.
                $scope.$watch(
                    () => controller.renaming,
                    (renaming: boolean) => {
                        if (!renaming) {
                            return;
                        }
                        $timeout(() => {
                            const root = element.get(0) as HTMLElement;
                            const input = root ? root.querySelector<HTMLInputElement>('input.gp-plan-card-rename-input') : null;
                            if (input) {
                                input.focus();
                                input.select();
                            }
                        });
                    }
                );

                // Thumbnails 404 (or come back as tiny placeholders) for plans
                // that predate thumbnail generation; show the fallback tile
                // instead of a broken image glyph.
                const img = element.find('img');
                img.on('error', () => element.addClass('gp-plan-card-thumb-failed'));
                img.on('load', () => {
                    const el = img.get(0) as HTMLImageElement;
                    if (el && el.naturalWidth < 2) {
                        element.addClass('gp-plan-card-thumb-failed');
                    } else {
                        element.addClass('gp-plan-card-thumb-loaded');
                    }
                });

                // A changed URL means a new snapshot: clear a failure so the
                // replacement gets a fresh chance, but keep the loaded state
                // while the previous PNG is still showing.
                $scope.$watch(
                    () => controller.project && controller.project.thumbnailUrl,
                    (newValue: string, oldValue: string) => {
                        if (newValue !== oldValue) {
                            element.removeClass('gp-plan-card-thumb-failed');
                            if (!newValue || !img.attr('src')) {
                                element.removeClass('gp-plan-card-thumb-loaded');
                            }
                        }
                    }
                );

                $scope.$emit('gp-project-item-linked');
            },
            controller: ProjectItemController,
            controllerAs: 'vm',
            bindToController: true,
            template: projectItemTemplate,
        });
    }]);
